export const CaretDownIcon = () => (
  <svg
    width="9"
    height="5"
    viewBox="0 0 9 5"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M7.58217 0C8.07917 0 8.33875 0.575167 8.03892 0.94675L7.99458 0.99575L4.49458 4.49575C4.39414 4.59619 4.2605 4.65652 4.11873 4.66543C3.97697 4.67435 3.83682 4.63123 3.72458 4.54417L3.66975 4.49575L0.16975 0.99575L0.121333 0.940917L0.0898335 0.896L0.0583336 0.84L0.0484168 0.819L0.0326668 0.779917L0.0140001 0.716917L0.00816663 0.686L0.00233344 0.651L0 0.61775V0.548917L0.00291673 0.515084L0.00816663 0.480083L0.0140001 0.44975L0.0326668 0.38675L0.0484168 0.347666L0.0892502 0.270667L0.127167 0.218166L0.16975 0.170917L0.224583 0.1225L0.2695 0.0910001L0.3255 0.0595001L0.3465 0.0495834L0.385584 0.0338331L0.448583 0.0151667L0.4795 0.00933321L0.5145 0.00349975L0.54775 0.00116658L7.58217 0Z" />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M2.33325 3.5H11.6666" />
    <path d="M3.5 7H10.5" />
    <path d="M5.25 10.5H8.75" />
  </svg>
);

export const ThreeDotsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="8" cy="3.5" r="1.4" />
    <circle cx="8" cy="8" r="1.4" />
    <circle cx="8" cy="12.5" r="1.4" />
  </svg>
);
